import { map, get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Sub, SubBold } from 'components/Sub';
import { largeUp, mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const CollectionSecondaryNavigationMobile = ({
  secondaryNavigationOptions,
  trackNavigation,
  experimentEngagementIds,
}) => (
  <div className="CollectionSecondaryNavigationMobile">
    {map(secondaryNavigationOptions, (option, index) => {
      const optionLabel = get(option, 'label');
      const optionLink = get(option, 'linkUrl');

      return (
        <div className="CollectionSecondaryNavigationMobile__options" key={index}>
          {get(option, 'isActive') ? (
            <SubBold>{optionLabel}</SubBold>
          ) : (
            <Sub>
              <a
                key={optionLabel}
                href={optionLink}
                onClick={() => trackNavigation(optionLink, experimentEngagementIds)}
                className="CollectionSecondaryNavigationMobile__options-link"
              >
                {optionLabel}
              </a>
            </Sub>
          )}
        </div>
      );
    })}
    <style jsx>{`
      .CollectionSecondaryNavigationMobile {
        width: 100%;
        display: flex;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        padding: ${Theme.get('spacing') * 2}px ${Theme.get('spacing') * 2}px;
        background-color: ${Theme.get('colors-grey')};
      }

      .CollectionSecondaryNavigationMobile::-webkit-scrollbar {
        display: none;
      }

      .CollectionSecondaryNavigationMobile__options {
        flex-shrink: 0;
        padding-left: ${Theme.get('spacing') * 3}px;
      }

      .CollectionSecondaryNavigationMobile__options:last-child {
        padding-right: ${Theme.get('spacing') * 5}px;
      }

      .CollectionSecondaryNavigationMobile__options-link {
        text-decoration: none;
        color: ${Theme.get('colors-black')};
        font-size: inherit;
      }

      @media ${mediumUp} {
          .CollectionSecondaryNavigationMobile {
            padding-left: ${Theme.get('spacing') * 3}px;
          }
        }
      } 

      @media ${largeUp} {
        .CollectionSecondaryNavigationMobile {
          padding-left: ${Theme.get('spacing') * 5}px;
        }
      }
      
    `}</style>
  </div>
);

CollectionSecondaryNavigationMobile.propTypes = {
  secondaryNavigationOptions: PropTypes.arrayOf(
    PropTypes.shape({
      linkUrl: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired,
    })
  ).isRequired,
  trackNavigation: PropTypes.func.isRequired,
  experimentEngagementIds: PropTypes.shape({
    dyDecisionId: PropTypes.string,
    dyVariationId: PropTypes.number,
  }),
};

CollectionSecondaryNavigationMobile.defaultProps = {
  experimentEngagementIds: {},
};

export default CollectionSecondaryNavigationMobile;
